import { createAction } from '../../../store.model';
import { ColourPoolItem } from '../../core/definition.scorecard.model';
import { PeriodType, ScorecardDto } from '../../scorecard.model';

import {
    RankFilter,
    ScorecardPublishStatusFilter,
    StcVerticalBarLineDataBar,
    SuperGroupFilter,
} from './scorecard-trend-chart.model';
import { View } from './scorecard-trend-chart.state';

export enum ActionType {
    SCORECARD_TREND__FILTER_RANKS = 'SCORECARD_TREND__FILTER_RANKS',
    SCORECARD_TREND__FILTER_SCORECARD_PUBLISH_STATUS = 'SCORECARD_TREND__FILTER_SCORECARD_PUBLISH_STATUS',
    SCORECARD_TREND__FILTER_SUPERGROUPS = 'SCORECARD_TREND__FILTER_SUPERGROUPS',
    SCORECARD_TREND__SET_FILTERS = 'SCORECARD_TREND__SET_FILTERS',
    SCORECARD_TREND__SET_CHART_DATA = 'SCORECARD_TREND__SET_CHART_DATA',
    SCORECARD_TREND__CHART_SELECTION_CHANGE = 'SCORECARD_TREND__CHART_SELECTION_CHANGE',
    SCORECARD_TREND__SELECT_VIEW = 'SCORECARD_TREND__SELECT_VIEW',
    SCORECARD_TREND__NAVIGATE = 'SCORECARD_TREND__NAVIGATE',
}

interface ScorecardHistory {
    scorecardHistory?: ScorecardDto[];
}

interface SelectedScorecard {
    selectedScorecardId: number;
}

export interface FilterRanks extends SelectedScorecard, ScorecardHistory {
    ranks: RankFilter[];
}

export const filterRanks = createAction<ActionType, FilterRanks>(
    ActionType.SCORECARD_TREND__FILTER_RANKS,
);

/// ///////

export interface FilterScorecardPublishStatus
    extends SelectedScorecard,
        ScorecardHistory {
    scorecardPublishStatuses: ScorecardPublishStatusFilter[];
}

export const filterScorecardPublishStatus = createAction<
    ActionType,
    FilterScorecardPublishStatus
>(ActionType.SCORECARD_TREND__FILTER_SCORECARD_PUBLISH_STATUS);

/// ///////

export interface FilterSuperGroups extends SelectedScorecard, ScorecardHistory {
    superGroups: SuperGroupFilter[];
}

export const filterSuperGroups = createAction<ActionType, FilterSuperGroups>(
    ActionType.SCORECARD_TREND__FILTER_SUPERGROUPS,
);

/// ///////

export interface SetTrendChartFilters extends ScorecardHistory {
    periodType: PeriodType;
    tabId: string;
    superGroupColourPool: ColourPoolItem[];
    rankColourPool: ColourPoolItem[];

    /** set to true to recreate the filters and reset current selections */
    reset?: boolean;
}

export const setTrendChartFilters = createAction<
    ActionType,
    SetTrendChartFilters
>(ActionType.SCORECARD_TREND__SET_FILTERS);

/// ///////

export interface SetTrendChartData extends SelectedScorecard, ScorecardHistory {
    periodType: PeriodType;
    tabId: string;
}

export const setTrendChartData = createAction<ActionType, SetTrendChartData>(
    ActionType.SCORECARD_TREND__SET_CHART_DATA,
);

/// ///////

export interface ScorecardTrendSelectionChange {
    selectedScorecard?: StcVerticalBarLineDataBar;
}

export const scorecardTrendSelectionChange = createAction<
    ActionType,
    ScorecardTrendSelectionChange
>(ActionType.SCORECARD_TREND__CHART_SELECTION_CHANGE);

/// ///////

export interface SelectView {
    view: View;
}

export const selectView = createAction<ActionType, SelectView>(
    ActionType.SCORECARD_TREND__SELECT_VIEW,
);

/// ///////

export interface Navigate {
    numPages: number;
}

export const navigate = createAction<ActionType, Navigate>(
    ActionType.SCORECARD_TREND__NAVIGATE,
);
